import {apiGet} from '../../utils/api';
import {config} from '../../config/app-config';
import {isAuthenticated} from '../auth';
import {loadContentForNewElements} from '../content-editor-src';

export class CourseLecturersSelector {
    constructor() {
        // ВАЖНО: Используем slug из URL для уникального ключа localStorage
        const urlParams = new URLSearchParams(window.location.search);
        const courseSlug = urlParams.get('slug') || 'default';

        this.storageKey = `course-lecturers-${courseSlug}`;
        this.selectedDoctorBlocks = JSON.parse(localStorage.getItem(this.storageKey) || '[]');

        console.log(`[CourseLecturersSelector] Initialized for course: ${courseSlug}`);
        this.init();
    }

    async init() {
        if (!window.location.pathname.match(/course-detail(\.html)?$/)) return;

        // Загружаем и показываем выбранных докторов
        await this.displaySelectedDoctors();

        // Добавляем кнопку выбора только для админа
        if (isAuthenticated()) {
            this.addSelectorButton();
        }
    }

    async displaySelectedDoctors() {
        const container = document.getElementById('course-selected-lecturers');
        if (!container) {
            console.warn('[CourseLecturersSelector] Container #course-selected-lecturers not found');
            return;
        }

        container.innerHTML = '';

        if (this.selectedDoctorBlocks.length === 0) {
            container.innerHTML = '<p>Лекторів ще не вибрано</p>';
            return;
        }

        // Горизонтальный скролл
        const doctorsWrapper = document.createElement('div');
        doctorsWrapper.className = 'doctors-wrapper';

        this.selectedDoctorBlocks.forEach(blockName => {
            const doctorCard = document.createElement('div');
            doctorCard.className = 'doctor-card-course';

            doctorCard.innerHTML = `
                <img src="" alt="" data-content="${blockName}-image" data-type="image" 
                     class="doctor-image">
                <h3 data-content="${blockName}-name" class="doctor-name"></h3>
                <p data-content="${blockName}-description" data-type="textarea" 
                   class="doctor-description"></p>
            `;

            doctorsWrapper.appendChild(doctorCard);
        });

        container.appendChild(doctorsWrapper);

        // Загружаем контент для новых элементов
        const contentElements = container.querySelectorAll('[data-content]');
        if (contentElements.length > 0) {
            await loadContentForNewElements(contentElements);
        }
    }

    addSelectorButton() {
        const section = document.getElementById('course-lecturers-section');
        if (!section) {
            console.warn('[CourseLecturersSelector] Section #course-lecturers-section not found');
            return;
        }

        // Проверяем, нет ли уже кнопки
        if (section.querySelector('.btn.btn-primary')) {
            return;
        }

        const btn = document.createElement('button');
        btn.textContent = 'Вибрати лекторів';
        btn.className = 'btn btn-primary';
        btn.style.cssText = `
            position: absolute;
            top: 20px;
            right: 20px;
            z-index: 10;
        `;

        btn.addEventListener('click', () => this.openSelector());
        section.style.position = 'relative';
        section.appendChild(btn);
    }

    async openSelector() {
        try {
            // Получаем список всех докторов
            const doctors = await apiGet(config.api.paths.doctorsWithContent, {auth: false});

            if (!Array.isArray(doctors)) {
                console.error('API did not return an array:', doctors);
                alert('Помилка: Список лекторів некоректний');
                return;
            }

            if (doctors.length === 0) {
                alert('Список лекторів порожній');
                return;
            }

            const modal = document.createElement('div');
            modal.className = 'lecturer-selector-modal';
            modal.style.cssText = `
                position: fixed;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background: rgba(0,0,0,0.8);
                display: flex;
                align-items: center;
                justify-content: center;
                z-index: 10000;
            `;

            const content = document.createElement('div');
            content.style.cssText = `
                background: white;
                padding: 30px;
                border-radius: 8px;
                max-width: 600px;
                max-height: 80vh;
                overflow-y: auto;
            `;

            content.innerHTML = `
                <h3>Виберіть лекторів для курсу</h3>
                <div class="doctors-list" style="margin: 20px 0;">
                    ${doctors.map(doc => `
                        <label style="display: block; margin: 10px 0; padding: 10px; border: 1px solid #ddd; border-radius: 4px; cursor: pointer;">
                            <input type="checkbox" 
                                   value="${doc.block_name}" 
                                   ${this.selectedDoctorBlocks.includes(doc.block_name) ? 'checked' : ''}
                                   style="margin-right: 10px;">
                            <strong>${doc.doctor_name}</strong> (${doc.block_name})
                        </label>
                    `).join('')}
                </div>
                <div style="text-align: right;">
                    <button class="btn btn-secondary" style="margin-right: 10px;">Скасувати</button>
                    <button class="btn btn-primary save-btn">Зберегти</button>
                </div>
            `;

            modal.appendChild(content);
            document.body.appendChild(modal);

            // Обработчик отмены
            content.querySelector('.btn.btn-secondary').addEventListener('click', () => {
                modal.remove();
            });

            // Обработчик сохранения
            content.querySelector('.save-btn').addEventListener('click', () => {
                const checkboxes = content.querySelectorAll('input[type="checkbox"]:checked');
                this.selectedDoctorBlocks = Array.from(checkboxes).map(cb => cb.value);

                // Сохраняем в localStorage с уникальным ключом для курса
                localStorage.setItem(this.storageKey, JSON.stringify(this.selectedDoctorBlocks));

                modal.remove();
                this.displaySelectedDoctors();
            });

        } catch (error) {
            console.error('Error loading doctors:', error);
            alert('Помилка завантаження списку лекторів: ' + error.message);
        }
    }
}